import { Drawer, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { Close } from "@mui/icons-material";

export const useMobileView = (filterContent) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = () => {
        setDrawerOpen(prev => !prev);
    };

    const mobileContext = isMobile ? (
        <>
            <IconButton onClick={toggleDrawer} sx={{ mb: 1 }}>
                <MenuIcon sx={{ color: "white" }} />
            </IconButton>

            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer}
            >
                <IconButton
                    onClick={toggleDrawer}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        zIndex: 1300,  // high zIndex to float above drawer content
                    }}
                    aria-label="close drawer"
                >
                    <Close />
                </IconButton>
                {filterContent}

            </Drawer>
        </>
    ) : null;

    return {
        isMobile,
        mobileContext,
        toggleDrawer,
    };
};
